import { City } from './types';

export const majorCities: City[] = [
  { name: "Chicago", population: 2746388, rank: 1 },
  { name: "Aurora", population: 180542, rank: 2 },
  { name: "Joliet", population: 150362, rank: 3 },
  { name: "Naperville", population: 149540, rank: 4 },
  { name: "Rockford", population: 147051, rank: 5 },
  { name: "Springfield", population: 114394, rank: 6 },
  { name: "Peoria", population: 113150, rank: 7 },
  { name: "Elgin", population: 112111, rank: 8 },
  { name: "Waukegan", population: 89321, rank: 9 },
  { name: "Champaign", population: 88029, rank: 10 }
];